import { FaRegCheckCircle } from "react-icons/fa";
import aiIcon from "../../../../assets/ai-icon-filled.svg";

import { PLUM_PURPLE_800, SUCCESS_GREEN } from "../../colors";
import FlexBox from "../../FlexBox";
import { Body1, H3 } from "../../Headings";
import { SessionBulletIcon, SessionBulletRow } from "../styles";

const IntakeReportsStep = () => (
  <FlexBox column rowGap="1.5rem">
    <FlexBox align="center" justify="center" columnGap="0.5rem">
      <img src={aiIcon} alt="AI icon" width="32" height="32" />
      <H3 bold color={PLUM_PURPLE_800}>
        Pre-Filled Intake Report
      </H3>
    </FlexBox>
    <FlexBox column rowGap="1rem">
      <SessionBulletRow>
        <SessionBulletIcon>
          <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
        </SessionBulletIcon>
        <Body1>
          Get <strong>auto-summarised intake reports</strong> for a quick,
          concise overview of client details.
        </Body1>
      </SessionBulletRow>

      <SessionBulletRow>
        <SessionBulletIcon>
          <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
        </SessionBulletIcon>
        <Body1>
          You no longer need to worry about or <strong>locate data</strong>.
          Simply ask AI.
        </Body1>
      </SessionBulletRow>

      <SessionBulletRow>
        <SessionBulletIcon>
          <FaRegCheckCircle size={18} color={SUCCESS_GREEN[700]} />
        </SessionBulletIcon>
        <Body1>
          <strong>Reduce the time spent on administrative tasks</strong> related
          to documentation by using Amaha AI for processes like summarising
          reports.
        </Body1>
      </SessionBulletRow>
    </FlexBox>
  </FlexBox>
);

export default IntakeReportsStep;
